var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2558 18.0703C15.7191 18.0703 14.4035 17.4805 13.3092 16.3009C12.2149 15.1213 11.6677 13.7033 11.6677 12.0469C11.6677 10.3904 12.2149 8.97241 13.3092 7.79282C14.4035 6.61323 15.7191 6.02344 17.2558 6.02344C18.7925 6.02344 20.108 6.61323 21.2024 7.79282C22.2967 8.97241 22.8439 10.3904 22.8439 12.0469C22.8439 13.7033 22.2967 15.1213 21.2024 16.3009C20.108 17.4805 18.7925 18.0703 17.2558 18.0703ZM6.07959 30.1172V25.9008C6.07959 25.0475 6.28356 24.2634 6.69149 23.5486C7.09942 22.8338 7.64053 22.2877 8.31483 21.9103C9.75842 21.1322 11.2253 20.549 12.7155 20.1604C14.2056 19.7719 15.7191 19.5772 17.2558 19.5762C18.7925 19.5762 20.306 19.7709 21.7961 20.1604C23.2863 20.55 24.7532 21.1332 26.1967 21.9103C26.872 22.2867 27.4136 22.8328 27.8215 23.5486C28.2294 24.2644 28.4329 25.0485 28.432 25.9008V30.1172H6.07959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.8b63073d47149fd11fbcdf00e1282e27.svg";
export { ForwardRef as ReactComponent };